import { useEffect, useState } from 'react';
import Input from '../../../components/TextField/Input';
import { styled, Typography } from '@mui/material';

const Title = styled(Typography)(({ theme }) => ({
  ...theme.externalTypography.body3,
  color: theme.color.secondary.$60,
}));

const SpanRequire = styled('span')`
  color: ${({ theme }) => theme.color.highlight};
`;

interface SettingSequenceSingleInputProps {
  handleOnChange: (e: string, index: number) => void;
  index: number;
  type: string;
}

const SettingSequenceSingleInput: React.FC<SettingSequenceSingleInputProps> = ({
  handleOnChange,
  index,
  type,
}) => {
  const [input, setInput] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');

  useEffect(() => {
    let temp: string = '';
    const typeRegexp = /([A-Za-z]+)\s*\(?\s*(\d+)\s*\)?/;
    const match = type.match(typeRegexp);
    let size;
    let dataType = '';
    if (match) {
      dataType = match[1];
      size = +match[2];
    }
    switch (dataType) {
      case 'Byte': {
        const invalidChars = input.match(/[^0-9A-F]/gi);
        if (input === '') {
          temp = `${dataType}: Empty Input`;
        } else if (invalidChars) {
          temp = `${dataType}: Invalid character '${invalidChars[invalidChars.length - 1]}'`;
        } else if (input.length % 2 !== 0) {
          temp = '${dataType}: Non-even number of characters';
        } else if (input.length > size * 2) {
          temp = `${dataType}: Invalid Size. Now is ${input.length / 2} byte(s) but max length is ${size} byte(s)`;
        }
        break;
      }
      case 'Char': {
        const invalidChars = input.match(/[^0-9A-Z]/gi);
        if (input === '') {
          temp = `${dataType}: Empty Input`;
        } else if (invalidChars) {
          temp = `${dataType}: Invalid character '${invalidChars[invalidChars.length - 1]}'`;
        } else if (size < input.length) {
          temp = `${dataType}: Invalid Size. Now is ${input.length} character(s) but max length is ${size} character(s)`;
        }
        break;
      }
      case 'Int': {
        const invalidChars = input.match(/[^0-9-]/g);
        if (input === '') {
          temp = `${dataType}: Empty Input`;
        } else if (invalidChars) {
          temp = `${dataType}: Invalid character '${invalidChars[invalidChars.length - 1]}'`;
        } else if (
          !(-Math.pow(2, size) / 2 <= +input && +input < Math.pow(2, size) / 2)
        ) {
          temp = `${dataType}: ${input} is out of range [-${Math.pow(2, size) / 2}, ${Math.pow(2, size) / 2 - 1}]`;
        }
        break;
      }
      case 'UInt': {
        const invalidChars = input.match(/[^0-9]/g);
        if (input === '') {
          temp = `${dataType}: Empty Input`;
        } else if (invalidChars) {
          temp = `${dataType}: Invalid character '${invalidChars[invalidChars.length - 1]}'`;
        } else if (!(0 <= +input && +input < Math.pow(2, size) - 1)) {
          temp = `${dataType}: ${input} is out of range [0, ${Math.pow(2, size) - 1}]`;
        }
        break;
      }
      default:
        temp = `Invalid dataType ${dataType}`;
        break;
    }
    setErrorMsg(temp);
  }, [input]);

  return (
    <>
      <span>
        <Title>
          {type} [{index}]<SpanRequire>*</SpanRequire>
        </Title>
      </span>
      <Input
        value={input}
        onChange={(e) => {
          setInput(e.currentTarget.value);
          handleOnChange(e.currentTarget.value as string, index);
        }}
        errorMessage={errorMsg}
      />
    </>
  );
};
export default SettingSequenceSingleInput;
